export default __webpack_public_path__ + "static/media/combo.723ba766.png";